import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import splashImg from '../../css/images/splash-profile.jpg'

export default function SplashRegister() {
  const navigate = useNavigate()

  useEffect(() => {
    if (localStorage.getItem('splashProfilerSeen')=='1') {

        navigate('/menume')
    }else{
      const timer = setTimeout(() => {
        localStorage.setItem('splashProfilerSeen', '1')
        navigate('/menume')
      }, 5000)
      return () => clearTimeout(timer)
    }

  }, [navigate])

  const handleClick = () => {
    localStorage.setItem('splashProfilerSeen', '1')
    navigate('/menume')
  }

  return (
    <div 
      onClick={handleClick}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        cursor: 'pointer',
        backgroundColor: '#000'
      }}
    >
      <img 
        src={splashImg} 
        alt="Welcome to 1,2,3 High Community"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
    </div>
  )
}
